import { Popover as AntdPopover } from "antd";
import "./style.scss";

function Popover({
  arrow = false,
  trigger = "click",
  content,
  children,
  className,
  placement = "bottomRight",
  isOpen,
  onOpenChange,
}) {
  return (
    <AntdPopover
      trigger={trigger}
      content={content}
      arrow={arrow}
      className={className}
      placement={placement}
      {...(isOpen !== undefined ? { open: isOpen } : {})}
      onOpenChange={onOpenChange}
    >
      {children}
    </AntdPopover>
  );
}

export default Popover;
